import {loggedGet} from '@/library/ajax'
import fn from '@/library/fn'

const apiUrl = process.env.VUE_APP_API_URL

export const getTeamById = () => {
  return loggedGet(apiUrl + '/company/' + fn.teamId(), {}, true)
}

export const getTrx = () => {
  return loggedGet(apiUrl + '/transactional', {})
}